import { Stack } from '@mui/material';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  text?: string | ReactNode;
  minHeight?: string;
  borderRadius?: string;
  background?: string;
}

EmptyData.defaultProps = {
  text: '데이터가 없습니다.',
  minHeight: 'auto',
  borderRadius: '0',
  background: 'none',
};

function EmptyData({ text, minHeight, borderRadius, background }: Props) {
  return (
    <Wrapper
      alignItems="center"
      gap="6px"
      justifyContent="center"
      minHeight={minHeight}
      borderRadius={borderRadius}
      sx={{
        background,
      }}
    >
      <AlertIcon />
      <div>{text}</div>
    </Wrapper>
  );
}

export default EmptyData;

const Wrapper = styled(Stack)`
  width: 100%;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 160% */
  letter-spacing: -0.1px;
  color: #bdbdbd;
`;

const AlertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="9" stroke="#BDBDBD" strokeWidth="2" />
      <path d="M12 7V13" stroke="#BDBDBD" strokeWidth="2" />
      <path d="M12 14V16" stroke="#BDBDBD" strokeWidth="2" />
    </svg>
  );
};
